<div class="email-search-container">
  <div class="d-flex">
    <span class="material-icons-outlined add-icon cmr-8">person_add</span>
    <div class="search-box">
      <div
        class="search-bar"
        [class.active]="isSearchFocused"
        [class.hover]="isSearchHovered"
        [class.has-email]="emails.length > 0"
        [class.invalid]="isInvalid"
        [class.show-email-chips]="showParsedEmailChips"
      >
        <div class="email-chip-list" *ngIf="showParsedEmailChips">
          <!-- This container is used to subscribe only once to the emailErrorMap$ observable and reuse its subscription for each email chip as needed -->
          <!-- Note that this will always evaluate to true since the emailErrorMap$ observable is always emitting a value, even if it's an empty map -->
          <ng-container *ngIf="emailErrorMap$ | async as emailErrorMap">
            <ng-container
              *ngIf="userSearchSelectionService.selectedUsers$ | async as selectedUsers"
            >
              <div
                *ngFor="let email of emails"
                class="email-chip ingestion"
                [class.invalid-email]="emailErrorMap.has(email)"
                [appTooltip]="emailErrorMap.get(email)"
                [appTooltipPlacement]="'top-center'"
                [appTooltipArrow]="'bottom'"
                [appTooltipDisabled]="!emailErrorMap.has(email)"
              >
                <span>
                  <span class="email-ellipsis">
                    {{ (selectedUsers | lookup: 'email':email)?.name ?? email }}
                  </span>
                </span>
                <span (click)="onRemoveUser(email)" class="closebtn"> &times; </span>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <input
          #userSearch
          [appTooltip]="labelTooltip"
          [appTooltipPlacement]="'top-center'"
          [appTooltipTriggerType]="'manual'"
          type="search"
          [(ngModel)]="searchQuery"
          placeholder="{{ emails.length ? '' : placeholder }}"
          autofocus="true"
          autocomplete="nope"
          (focus)="onFocusSearch()"
          (blur)="onBlurSearch()"
          (input)="onInputChange()"
          (mouseover)="isSearchHovered = true"
          (mouseout)="isSearchHovered = false"
          (keypress)="onKeyPress($event)"
          (paste)="onPaste($event)"
          #emailInvalidTooltip="appTooltip"
          appUserSearchInput
        />
        <ng-template #labelTooltip>
          <app-tooltip
            arrow="bottom"
            theme="red"
            [text]="'Invalid email address' | translate"
          ></app-tooltip>
        </ng-template>
      </div>
    </div>
  </div>
  <div
    class="search-results-container"
    *ngIf="!suggestUsers && searchQuery.length && !emails.includes(searchQuery) && validEmailInput"
    [style.max-height]="emails.length ? '130px' : '185px'"
  >
    <div class="search-result-option" (click)="addUser(searchQuery)">
      <svg-icon class="user-photo" [icon]="'user'" [width]="30" [height]="30"></svg-icon>
      <div class="cml-8 d-inline-flex flex-column user-info-cont">
        <span class="name">{{ searchQuery }}</span>
      </div>
    </div>
  </div>
  <div
    *ngIf="suggestUsers && isSearchFocused && searchQuery.length && !isInvalid"
    class="suggest-users-container"
  >
    <div
      *ngIf="userSearchDirective?.isLoading$ | async; else searchResults"
      class="search-loading-row"
      aria-hidden="true"
    >
      <app-pencil-spinner [diameter]="18" [strokeWidth]="3"></app-pencil-spinner>
    </div>
    <ng-template #searchResults>
      <div
        class="invite-email-indicator"
        *ngIf="validEmailInput && !(userSearchDirective?.filteredUsers$ | async)?.length"
      >
        <div
          class="search-result-option"
          role="button"
          (mousedown)="processTypedEmail(searchQuery)"
        >
          <div class="d-flex align-items-center position-relative">
            <svg-icon class="user-photo" [icon]="'user'" [width]="45" [height]="45"></svg-icon>
            <div class="cml-8 d-inline-flex flex-column user-info-cont">
              <span class="name">{{ searchQuery }}</span>
              <span class="more-info">
                {{ 'Outside of institution' | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngFor="let user of userSearchDirective?.filteredUsers$ | async; trackBy: userTrackBy"
        class="search-result-option"
        role="button"
        (mousedown)="selectUser(user)"
      >
        <div class="d-flex align-items-center position-relative">
          <img [src]="user?.profile_image" *ngIf="user?.profile_image" class="user-photo" />
          <svg-icon
            *ngIf="!user"
            class="user-photo"
            [icon]="'user'"
            [width]="45"
            [height]="45"
            [ngbTooltip]="'This user doesn\'t exist anymore' | translate"
          ></svg-icon>
          <div *ngIf="user && !user.profile_image" class="user-photo" [style.font-size]="'16px'">
            {{ user?.name | shortName }}
          </div>
          <div class="cml-8 d-inline-flex flex-column user-info-cont">
            <span class="name">{{ user?.name }}</span>
            <span class="more-info">
              {{ user?.personas[0] ? user?.personas[0] + ' | ' : '' }}
              {{ user?.email }}</span
            >
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
<div class="error-message-container">
  <div *ngFor="let errorMessage of errorMessages$ | async">{{ errorMessage }}</div>
</div>
